import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/front/FrontHome.vue'
import Login from '@/views/front/Login.vue'

export const routes = [
  {
    path: '/',
    component: () => import('@/layouts/FrontLayout.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: 'login',
        name: 'Login',
        component: Login
      }
    ],
    meta: {
      title: '主页'
    }
  },
  {
    path: '/jsdaixie',
    name: 'JSDaixie',
    component: () => import('@/views/front/JSDaixie.vue')
  },
  {
    path: '/help/:pageUrl?',
    name: 'Help',
    component: () => import('@/views/front/Help.vue'),
    props: true,
    meta: {
      title: '键鼠任务教程'
    }
  },
  {
    path: '',
    name: 'FrontHome',
    component: () => import('@/views/front/FrontHome.vue'),
    props: true,
    meta: {
      title: '键鼠自动化'
    }
  },
  {
    path: '/jsdaixie',
    name: 'JSDaixie',
    component: () => import('@/views/front/JSDaixie.vue'),
    props: true,
    meta: {
      title: '键鼠代写'
    }
  },
  {
    path: '/AiBot',
    name: 'AiBot',
    component: () => import('@/views/front/AiBot.vue'),
    props: true,
    meta: {
      title: '键鼠AI'
    }
  },
  {
    path: '/register_content',
    name: 'registerContent',
    component: () => import('@/views/front/register_content.vue'),
    props: true
  },
  {
    path: '/register/:inviter?',
    name: 'register',
    component: () => import('@/views/front/register.vue'),
    props: true
  },
  {
    path: '/jsautotask_disclaimer',
    name: 'registerDisclaimer',
    component: () => import('@/views/front/jsautotask_disclaimer.vue'),
    props: true
  }
]

export const history = createWebHistory('/')

export const guards = [
  async (from, to) => {
    if (to.meta.title) {
      document.title = to.meta.title;
    }
    return true
  }
]

const router = createRouter({ history, routes })
export default router


// 可选的全局旧路径处理（需放在路由最后）
routes.push({ 
  path: '/:path(.+)\\.html',
  redirect: to => {
    const basePath = to.path.split('.html')[0]; 
    const target = routes.find(r  => r.meta?.legacyAlias  === to.path); 
    return target ? { name: target.name  } : basePath;
  }
});